// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"ae34008a","498":"96f98f77","513":"805496e7","787":"21043167"}[chunkId] + ".chunk.js";
};